import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import DocumentationPage from './DocumentationPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<DocumentationPage />} />
      </Routes>
    </Router>
  );
}

export default App;
